module.exports = __webpack_public_path__ + "img/chinesecompany179.d4341d61.png";